import { modifyImportUrls } from "src/start-single-spa/modifyImportUrls";

modifyImportUrls().then((importMap) => {
    System.addImportMap(importMap);
    return System.import("@newsenec/root-config");
});
